import type { PortfolioItem } from "@/lib/api";

type PortfolioLanguage = "en" | "ar" | "tr" | "de" | "ku";

const supportedLanguages: PortfolioLanguage[] = ["en", "ar", "tr", "de", "ku"];

const getPortfolioLanguage = (language: string): PortfolioLanguage => {
  const languageCode = language.toLowerCase().split("-")[0];
  return supportedLanguages.includes(languageCode as PortfolioLanguage)
    ? (languageCode as PortfolioLanguage)
    : "en";
};

const translatedValue = (
  values: PortfolioItem["title_i18n"] | PortfolioItem["description_i18n"],
  language: string,
  fallback: string,
) => {
  const currentLanguage = getPortfolioLanguage(language);
  return values?.[currentLanguage]?.trim() || values?.en?.trim() || fallback;
};

export const getPortfolioTitle = (project: PortfolioItem, language: string) =>
  translatedValue(project.title_i18n, language, project.title);

export const getPortfolioDescription = (project: PortfolioItem, language: string) =>
  translatedValue(project.description_i18n, language, project.description);